// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";

function StockActivitySourceTableCell(props) {
  let shopName = props.shopName;
  return JsxRuntime.jsxs(Stack.make, {
    children: [
      JsxRuntime.jsx(TextStyle.make, {
        children: props.deviceName
      }),
      shopName !== undefined ? JsxRuntime.jsx(TextStyle.make, {
          children: shopName,
          variation: "normal",
          size: "xxsmall"
        }) : null
    ],
    space: Stdlib_Option.isSome(shopName) ? "xxsmall" : "none"
  });
}

let make = React.memo(StockActivitySourceTableCell);

export {
  make,
}
/* make Not a pure module */
